export default __webpack_public_path__ + "static/media/fishshoal.d4c293dd.jpg";